export default {
      id: "business-thumbs-up-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#business-thumbs-up-usage",
      toString: function () {
        return this.url;
      }
    }